import React from 'react';

const ToggleNav = ({
  options,
  activeId,
  onChange,
  className = '',
  activeClassName = 'bg-primary text-white',
  inactiveClassName = 'text-gray-800 hover:text-gray-800',
  size = 'default',
  disabled = false,
}) => {
  // Size variants
  const sizeClasses = {
    sm: 'py-1 px-4 text-xs',
    default: 'py-[6px] sm:py-[11px] px-2 w-full text-sm',
    lg: 'py-3 px-8 text-base',
  };

  if (options?.length === 0) return null;

  return (
    <div
      className={`flex items-center rounded-full p-1 bg-gray-100 h-[40px] sm:h-[50px] ${className} ${
        disabled ? 'opacity-50 cursor-not-allowed pointer-events-none' : ''
      }`}
    >
      {options.map((option) => (
        <button
          key={option.id}
          onClick={() => {
            if (activeId === option?.id) {
              return;
            }

            onChange?.(option.id);
          }}
          className={`
            ${sizeClasses[size]} 
            rounded-full 
            font-semibold 
            transition-colors 
            duration-200
            flex-1
            ${activeId === option.id ? activeClassName : inactiveClassName}
            ${options?.length === 1 ? 'cursor-auto' : ''}
          `}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
};

export default ToggleNav;
